// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XD1Et2X39v {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.XD1Et2X39v h4 {
  line-height: 3em;
}
.XD1Et2X39v .mBsnghjN2M {
  float: left;
  width: 100%;
}
.XD1Et2X39v .dDS7S_IJiI {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.XD1Et2X39v .dDS7S_IJiI:hover {
  cursor: pointer;
}
.XD1Et2X39v .dDS7S_IJiI:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.YdHD3nqA1c .cWUu_t6AGR:focus {
  outline: none;
}
.YdHD3nqA1c .cWUu_t6AGR.mOGakUuF7U.xQax4fZFKq {
  background: #375A88;
}
.YdHD3nqA1c .cWUu_t6AGR.mOGakUuF7U.xQax4fZFKq span {
  color: #fff;
}
.YdHD3nqA1c .xQax4fZFKq {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.YdHD3nqA1c .xQax4fZFKq:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.YdHD3nqA1c input {
  height: 38px;
  min-width: 220px;
}
.dDS7S_IJiI.bxe4YVJF5P {
  background: #410102;
}
.dDS7S_IJiI.vwwCaSe24Q {
  background: #911318;
}
.dDS7S_IJiI.Iv1I6fZyCC {
  background: #D8293B;
}
.dDS7S_IJiI.wHqz3OgPYM {
  background: #F2373C;
}
.dDS7S_IJiI.aNF4nZr27O {
  background: #FC4448;
}
.dDS7S_IJiI.gv7qsffiET {
  background: #ED535E;
}
.dDS7S_IJiI.UKLAv3qDYs {
  background: #E34926;
}
.dDS7S_IJiI.X3DwgpT9pu {
  background: #FC562B;
}
.dDS7S_IJiI.NyNyNDhd0Q {
  background: #FC6722;
}
.dDS7S_IJiI.GeoZFJonYg {
  background: #FD7F24;
}
.dDS7S_IJiI.TKxtFjZzX0 {
  background: #FD8D26;
}
.dDS7S_IJiI.OUGo4SYHTu {
  background: #EC9C3E;
}
.dDS7S_IJiI.HB_vKcseLm {
  background: #0e673a;
}
.dDS7S_IJiI.AU2WWWZw5w {
  background: #208740;
}
.dDS7S_IJiI.eoTbymGEPA {
  background: #239718;
}
.dDS7S_IJiI.aQ_M8Nk3we {
  background: #55A84D;
}
.dDS7S_IJiI.LNVfqMkRTD {
  background: #4BBE5A;
}
.dDS7S_IJiI.C5jAjBPiT7 {
  background: #0CCA6A;
}
.dDS7S_IJiI.jDtCBpiQx7 {
  background: #0A3C64;
}
.dDS7S_IJiI.iybvqqPMGl {
  background: #0d487a;
}
.dDS7S_IJiI.qE6KKnv8bR {
  background: #10538d;
}
.dDS7S_IJiI.sTvDRaC8Pe {
  background: #115A99;
}
.dDS7S_IJiI._ziG9br1Ur {
  background: #3387E2;
}
.dDS7S_IJiI.GxVPLzmIIM {
  background: #1BA9CF;
}
.dDS7S_IJiI.p6UhGgdab2 {
  background: #d27c02;
}
.dDS7S_IJiI.Pjmw47xS0Q {
  background: #fb9402;
}
.dDS7S_IJiI.Mr6DsX4WZl {
  background: #FD9B30;
}
.dDS7S_IJiI.TyPnnu40Ds {
  background: #FDBE2D;
}
.dDS7S_IJiI.T8aVQuOiLZ {
  background: #FED831;
}
.dDS7S_IJiI.Mgy9ZO6qVL {
  background: #FFFD38;
}
.dDS7S_IJiI.d5L8FJqx1r {
  background: #2D215C;
}
.dDS7S_IJiI.k6TeG26v3g {
  background: #483C83;
}
.dDS7S_IJiI.MXK0luoBjM {
  background: #58518d;
}
.dDS7S_IJiI.AMazuA1fuU {
  background: #7068A9;
}
.dDS7S_IJiI.nWuV8Xpbto {
  background: #7f78b2;
}
.dDS7S_IJiI.MQ2P2EUXNa {
  background: #8f88bc;
}
.dDS7S_IJiI._pUUm2fbw5 {
  background: #000;
}
.dDS7S_IJiI.HCQZYPbRQI {
  background: #282626;
}
.dDS7S_IJiI.zouYksUTzQ {
  background: #242222;
}
.dDS7S_IJiI.lWWRBqotYx {
  background: #353838;
}
.dDS7S_IJiI.oUnuBObR5H {
  background: #666;
}
.dDS7S_IJiI.wUyNiCNBaL {
  background: #999;
}
.Wu68rz_6X5 {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.Wu68rz_6X5 .tVxch2WxkV {
  display: none;
}
.ZbxTKhi29Z.ZbxTKhi29Z {
  max-width: 800px;
  width: 800px;
}
.ZbxTKhi29Z.ZbxTKhi29Z .Q88GGae5j8 {
  min-height: 80px;
}
.ZbxTKhi29Z.ZbxTKhi29Z .FOePrKn330 {
  margin-bottom: 24px;
}
.x0ryiaCxar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.UeKuMT0OIW {
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #222222;
  line-height: 16px;
  font-size: 12px;
  padding-top: 52px;
}
.UeKuMT0OIW .X_zj1Vx9xH {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 4px;
  margin-top: 8px;
  line-height: 24px;
  max-width: 600px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
.UeKuMT0OIW .xTviSOGNrd {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
  line-height: 24px;
}
.UeKuMT0OIW .wOGBGbeWT8 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
}
.R7oqV7a3XX {
  display: flex;
  flex-direction: row;
  padding-bottom: 52px;
}
.R7oqV7a3XX .PkvpI9LP6q {
  height: 32px;
  font-weight: normal;
}
.R7oqV7a3XX .yPvATrZbYo {
  padding: 0px 48px;
}
.R7oqV7a3XX .sLregPoIDA {
  margin-left: 8px;
}
.x0ryiaCxar .xke9UHu1hV.xke9UHu1hV {
  font-size: 12px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `XD1Et2X39v`,
	"color-row": `mBsnghjN2M`,
	"color-tile": `dDS7S_IJiI`,
	"picker-component": `YdHD3nqA1c`,
	"picker-element": `cWUu_t6AGR`,
	"active": `mOGakUuF7U`,
	"btn": `xQax4fZFKq`,
	"red-1": `bxe4YVJF5P`,
	"red-2": `vwwCaSe24Q`,
	"red-3": `Iv1I6fZyCC`,
	"red-4": `wHqz3OgPYM`,
	"red-5": `aNF4nZr27O`,
	"red-6": `gv7qsffiET`,
	"orange-1": `UKLAv3qDYs`,
	"orange-2": `X3DwgpT9pu`,
	"orange-3": `NyNyNDhd0Q`,
	"orange-4": `GeoZFJonYg`,
	"orange-5": `TKxtFjZzX0`,
	"orange-6": `OUGo4SYHTu`,
	"green-1": `HB_vKcseLm`,
	"green-2": `AU2WWWZw5w`,
	"green-3": `eoTbymGEPA`,
	"green-4": `aQ_M8Nk3we`,
	"green-5": `LNVfqMkRTD`,
	"green-6": `C5jAjBPiT7`,
	"blue-1": `jDtCBpiQx7`,
	"blue-2": `iybvqqPMGl`,
	"blue-3": `qE6KKnv8bR`,
	"blue-4": `sTvDRaC8Pe`,
	"blue-5": `_ziG9br1Ur`,
	"blue-6": `GxVPLzmIIM`,
	"yellow-1": `p6UhGgdab2`,
	"yellow-2": `Pjmw47xS0Q`,
	"yellow-3": `Mr6DsX4WZl`,
	"yellow-4": `TyPnnu40Ds`,
	"yellow-5": `T8aVQuOiLZ`,
	"yellow-6": `Mgy9ZO6qVL`,
	"purple-1": `d5L8FJqx1r`,
	"purple-2": `k6TeG26v3g`,
	"purple-3": `MXK0luoBjM`,
	"purple-4": `AMazuA1fuU`,
	"purple-5": `nWuV8Xpbto`,
	"purple-6": `MQ2P2EUXNa`,
	"black-1": `_pUUm2fbw5`,
	"black-2": `HCQZYPbRQI`,
	"black-3": `zouYksUTzQ`,
	"black-4": `lWWRBqotYx`,
	"black-5": `oUnuBObR5H`,
	"black-6": `wUyNiCNBaL`,
	"picker-theme": `Wu68rz_6X5`,
	"arrow-regular": `tVxch2WxkV`,
	"review-modal__root": `ZbxTKhi29Z`,
	"header-root": `Q88GGae5j8`,
	"header-root__close-btn": `FOePrKn330`,
	"cancel-review-modal": `x0ryiaCxar`,
	"cancel-review-modal__content": `UeKuMT0OIW`,
	"primary-text": `X_zj1Vx9xH`,
	"secondary-text": `xTviSOGNrd`,
	"confirm-text": `wOGBGbeWT8`,
	"cancel-review-modal__buttonCtn": `R7oqV7a3XX`,
	"cancel-review-modal__button": `PkvpI9LP6q`,
	"cancel-review-modal__button--cancel": `yPvATrZbYo`,
	"cancel-review-modal__button--cancel-review": `sLregPoIDA`,
	"cancel-review-modal__icon": `xke9UHu1hV`
};
export default ___CSS_LOADER_EXPORT___;
